import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import { useModal } from 'context/Modal/Context';
import useCardsApi, { CardsFilters } from 'hooks/queries/cards/useCardsApi';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { NestedFormValues } from 'utils/filters/convertToDotNotation';
import { getDirtyValues } from 'utils/form/getDirtyValues';

type Payload = Array<{ card: string; quantity: number }>;
type Props = {
  onSubmit: (p: Payload) => void;
};

const DEFAULT_FILTERS = { collection: true };

const useCardTradeListPickModal = ({ onSubmit }: Props) => {
  const [filters, setFilters] = useState<Partial<CardsFilters>>({});
  const { cards, totalItems, cardsQuery } = useCardsApi({
    filters: { ...filters, ...DEFAULT_FILTERS },
    controlled: true,
  });
  const { closeModal } = useModal();

  const formMethods = useForm<NestedFormValues>({
    mode: 'onSubmit',
  });

  const { reset } = formMethods;
  const {
    formState: { dirtyFields },
  } = formMethods;

  const onFilterSubmit = (values: Partial<CardsFilters>) => {
    setFilters(values);
    closeModal(MODAL_NAME.FILTERS);
  };

  const handleSubmit = (formValues: NestedFormValues) => {
    const values = getDirtyValues(dirtyFields, formValues);
    const formatted = Object.keys(values).reduce(
      (acc: Payload, cardIri) => [
        ...acc,
        {
          card: cardIri,
          quantity: values[cardIri],
        },
      ],
      [],
    );

    onSubmit(formatted);
  };

  const onClear = () => setFilters(DEFAULT_FILTERS);

  useEffect(() => {
    if (cards.length && cardsQuery.isFetchedAfterMount) {
      const formated = cards.reduce((acc, curr) => {
        return { ...acc, [curr['@id'] || '']: curr.stats?.inMyTradelist };
      }, {});

      reset(formated, { keepDirty: true, keepDirtyValues: true });
    }
  }, [cards, cardsQuery.isFetchedAfterMount]);

  return {
    cards,
    formMethods,
    onFilterSubmit,
    handleSubmit: formMethods.handleSubmit(handleSubmit),
    totalItems,
    filters,
    setFilters,
    onClear,
  };
};

export default useCardTradeListPickModal;
